(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blick-ins-buch"] && !Shopify.designMode) return;
  try {
    
  // Nur ASCII in diesem Block: der lokale theme-dev-Server setzt bei
  // compiled_assets/scripts.js Content-Length in Zeichen statt Bytes und
  // schneidet das Bundle sonst um die Mehrbyte-Zeichen ab - der Rest der
  // Datei ist dann Syntaxmuell und KEIN Section-JS auf der Seite laeuft.
  (function () {
    function StlBib(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-stl-bib-viewport]');
      this.book = root.querySelector('[data-stl-bib-book]');
      if (!this.viewport || !this.book) return;

      this.sheets = Array.prototype.slice.call(root.querySelectorAll('[data-stl-bib-sheet]'));
      if (!this.sheets.length) return;

      this.prevBtn = root.querySelector('[data-stl-bib-prev]');
      this.nextBtn = root.querySelector('[data-stl-bib-next]');
      this.statusEl = root.querySelector('[data-stl-bib-status]');

      this.sheetCount = this.sheets.length;
      this.totalPages = parseInt(root.getAttribute('data-total-pages'), 10) || this.sheetCount * 2;
      this.maxFlipped = parseInt(root.getAttribute('data-max-flipped'), 10);
      if (isNaN(this.maxFlipped)) this.maxFlipped = this.sheetCount;
      this.flipMs = parseInt(root.getAttribute('data-flip-ms'), 10) || 950;
      this.autoplay = root.getAttribute('data-autoplay') === 'true';

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      // flipped = Anzahl umgeblaetterter Blaetter. Sichtbare Doppelseite:
      // links die Rueckseite von Blatt flipped-1, rechts die Vorderseite von
      // Blatt flipped.
      this.flipped = parseInt(root.getAttribute('data-start-flipped'), 10) || 0;
      if (this.flipped > this.maxFlipped) this.flipped = this.maxFlipped;

      this.touched = false;
      this.zTimer = null;

      this.bind();
      this.render();

      // Erste Darstellung ohne Animation, danach freigeben.
      var book = this.book;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          book.classList.remove('stl-bib--no-anim');
        });
      });

      if (this.autoplay) this.watchForTeaser();
    }

    /* ---------- Zustand ---------- */

    StlBib.prototype.canNext = function () {
      return this.flipped < this.maxFlipped;
    };

    StlBib.prototype.canPrev = function () {
      return this.flipped > 0;
    };

    StlBib.prototype.next = function () {
      if (!this.canNext()) return;
      var turning = this.sheets[this.flipped];
      this.flipped++;
      this.render(turning);
    };

    StlBib.prototype.prev = function () {
      if (!this.canPrev()) return;
      this.flipped--;
      this.render(this.sheets[this.flipped]);
    };

    /* ---------- Darstellung ---------- */

    StlBib.prototype.render = function (turning) {
      var self = this;

      this.sheets.forEach(function (sheet, i) {
        sheet.classList.toggle('is-flipped', i < self.flipped);
      });

      // Das drehende Blatt muss waehrend der Drehung ueber allen anderen
      // liegen, danach wird es wieder einsortiert.
      if (turning) {
        turning.style.zIndex = this.sheetCount + 2;
        if (this.zTimer) clearTimeout(this.zTimer);
        var onEnd = function (e) {
          if (e.propertyName !== 'transform' || e.target !== turning) return;
          turning.removeEventListener('transitionend', onEnd);
          self.settleZ();
        };
        turning.addEventListener('transitionend', onEnd);
        // Fallback, falls transitionend ausbleibt (z. B. Tab im Hintergrund).
        this.zTimer = setTimeout(function () {
          self.settleZ();
        }, this.flipMs + 120);
      } else {
        this.settleZ();
      }

      if (this.prevBtn) this.prevBtn.disabled = !this.canPrev();
      if (this.nextBtn) this.nextBtn.disabled = !this.canNext();
      this.renderStatus();
    };

    StlBib.prototype.settleZ = function () {
      var self = this;
      this.sheets.forEach(function (sheet, i) {
        sheet.style.zIndex = i < self.flipped ? i : self.sheetCount - i;
      });
    };

    StlBib.prototype.renderStatus = function () {
      if (!this.statusEl) return;
      var total = this.totalPages;
      var text;

      if (this.flipped === 0) {
        text = 'Seite 1 von ' + total;
      } else {
        var left = this.flipped * 2;
        var right = left + 1;
        text = right <= total ? 'Seiten ' + left + '\u2013' + right + ' von ' + total : 'Seite ' + left + ' von ' + total;
      }
      this.statusEl.textContent = text;
    };

    /* ---------- Bedienung ---------- */

    StlBib.prototype.bind = function () {
      var self = this;

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.touched = true;
          self.next();
        });
      }
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.touched = true;
          self.prev();
        });
      }

      // Klick auf die rechte Haelfte blaettert vor, auf die linke zurueck.
      this.viewport.addEventListener('click', function (e) {
        // Nach einer Wischgeste feuert je nach Browser noch ein Klick - der
        // wuerde ein zweites Mal blaettern.
        if (self.swiped) return;
        self.touched = true;
        var rect = self.viewport.getBoundingClientRect();
        if (e.clientX - rect.left > rect.width / 2) {
          self.next();
        } else {
          self.prev();
        }
      });

      this.viewport.addEventListener('keydown', function (e) {
        var handled = true;
        if (e.key === 'ArrowRight' || e.key === 'PageDown') {
          self.next();
        } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
          self.prev();
        } else if (e.key === 'Home') {
          self.flipped = 0;
          self.render();
        } else if (e.key === 'End') {
          self.flipped = self.maxFlipped;
          self.render();
        } else {
          handled = false;
        }
        if (handled) {
          self.touched = true;
          e.preventDefault();
        }
      });

      var startX = null;
      var startY = null;
      this.viewport.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      this.viewport.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          // Nur waagerechte Gesten - senkrechtes Scrollen nicht abfangen.
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            self.swiped = true;
            self.touched = true;
            if (dx < 0) {
              self.next();
            } else {
              self.prev();
            }
            setTimeout(function () {
              self.swiped = false;
            }, 400);
          }
          startX = null;
          startY = null;
        },
        { passive: true }
      );
    };

    // Einmal von selbst anblaettern, sobald die Section sichtbar wird -
    // macht ohne Worte klar, dass man hier blaettern kann.
    StlBib.prototype.watchForTeaser = function () {
      if (this.reduced.matches || !('IntersectionObserver' in window)) return;
      var self = this;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            setTimeout(function () {
              if (!self.touched && self.canNext()) self.next();
            }, 700);
          });
        },
        { threshold: 0.4 }
      );
      io.observe(this.root);
      this.io = io;
    };

    StlBib.prototype.destroy = function () {
      if (this.zTimer) clearTimeout(this.zTimer);
      if (this.io) this.io.disconnect();
    };

    /* ---------- Bootstrap ---------- */

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-stl-bib]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.__stlBib) return;
        root.__stlBib = new StlBib(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme-Editor
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-stl-bib]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.__stlBib && root.__stlBib.destroy) root.__stlBib.destroy();
      });
    });

    // Andere Bausteine duerfen eine Kopie des Buches zum Leben erwecken -
    // die Uebersicht im Personalisierungs-Overlay klont diese Section und
    // ruft init() auf der Kopie auf (siehe assets/custom-alert-button.js).
    window.StarTalesBlickInsBuch = { init: initAll };

    // Im Editor zur ausgewaehlten Seite blaettern.
    document.addEventListener('shopify:block:select', function (e) {
      var face = e.target.closest ? e.target.closest('.stl-bib__face') : null;
      if (!face) return;
      var root = face.closest('[data-stl-bib]');
      var instance = root && root.__stlBib;
      if (!instance) return;
      var sheet = face.closest('[data-stl-bib-sheet]');
      var i = instance.sheets.indexOf(sheet);
      if (i < 0) return;

      var isBack = face.classList.contains('stl-bib__face--back');
      instance.touched = true;
      instance.flipped = isBack ? i + 1 : i;
      if (instance.flipped > instance.maxFlipped) instance.flipped = instance.maxFlipped;
      instance.render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qualitaetsmerkmale"] && !Shopify.designMode) return;
  try {
    
  // Nur ASCII in diesem Block: der lokale theme-dev-Server setzt bei
  // compiled_assets/scripts.js Content-Length in Zeichen statt Bytes und
  // schneidet das Bundle sonst um die Mehrbyte-Zeichen ab - der Rest der
  // Datei ist dann Syntaxmuell und KEIN Section-JS auf der Seite laeuft.
  (function () {
    function StlBookCallouts(root) {
      this.root = root;
      this.stage = root.querySelector('[data-stl-bc-stage]');
      this.svg = root.querySelector('.stl-bc__lines');
      if (!this.stage || !this.svg) return;
      this.mq = window.matchMedia('(min-width: 861px)');
      this.draw = this.draw.bind(this);
      this.init();
    }

    StlBookCallouts.prototype.init = function () {
      var img = this.root.querySelector('.stl-bc__img');
      if (img && img.tagName === 'IMG' && !img.complete) {
        img.addEventListener('load', this.draw);
      }
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.draw);
        this.ro.observe(this.stage);
      }
      window.addEventListener('resize', this.draw);
      if (this.mq.addEventListener) {
        this.mq.addEventListener('change', this.draw);
      }
      // Fonts koennen die Karten-Hoehe veraendern -> nach Load neu zeichnen
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.draw);
      }
      this.draw();
    };

    StlBookCallouts.prototype.draw = function () {
      var svg = this.svg;
      while (svg.firstChild) svg.removeChild(svg.firstChild);

      if (!this.mq.matches) return; // Mobil: keine Linien

      var stageRect = this.stage.getBoundingClientRect();
      if (!stageRect.width || !stageRect.height) return;

      svg.setAttribute('viewBox', '0 0 ' + stageRect.width + ' ' + stageRect.height);

      var dots = this.stage.querySelectorAll('[data-stl-bc-dot]');
      var leftItems = this.stage.querySelectorAll('.stl-bc__side--left [data-stl-bc-item]');
      var rightItems = this.stage.querySelectorAll('.stl-bc__side--right [data-stl-bc-item]');
      var ns = 'http://www.w3.org/2000/svg';

      var self = this;
      // Dots sind in Reihenfolge: erst alle linken, dann alle rechten.
      var ordered = [];
      Array.prototype.forEach.call(leftItems, function (it) { ordered.push({ item: it, side: 'left' }); });
      Array.prototype.forEach.call(rightItems, function (it) { ordered.push({ item: it, side: 'right' }); });

      ordered.forEach(function (entry, i) {
        var dot = dots[i];
        if (!dot) return;
        var dRect = dot.getBoundingClientRect();
        var iRect = entry.item.getBoundingClientRect();

        var dx = dRect.left + dRect.width / 2 - stageRect.left;
        var dy = dRect.top + dRect.height / 2 - stageRect.top;

        // Ankerpunkt an der bildzugewandten Kante der Karte
        var ax, ay = iRect.top + iRect.height / 2 - stageRect.top;
        if (entry.side === 'left') {
          ax = iRect.right - stageRect.left;
        } else {
          ax = iRect.left - stageRect.left;
        }

        var line = document.createElementNS(ns, 'line');
        line.setAttribute('x1', ax);
        line.setAttribute('y1', ay);
        line.setAttribute('x2', dx);
        line.setAttribute('y2', dy);
        svg.appendChild(line);
      });
    };

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.stl-bc');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.__stlBc) return;
        root.__stlBc = new StlBookCallouts(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme-Editor: neu initialisieren / zeichnen
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:reorder', function () { initAll(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randlos-gedruckt"] && !Shopify.designMode) return;
  try {
    
  // Nur ASCII in diesem Block: der lokale theme-dev-Server setzt bei
  // compiled_assets/scripts.js Content-Length in Zeichen statt Bytes und
  // schneidet das Bundle sonst um die Mehrbyte-Zeichen ab - der Rest der
  // Datei ist dann Syntaxmuell und KEIN Section-JS auf der Seite laeuft.
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Fallback-Schalter. Wo der Browser den Einflug selbst faehrt, halten wir
    // uns raus; sonst ist das hier die Notloesung - dieselbe Strecke, dieselbe
    // Kurve, nur im Main Thread und damit einen Tick hinterher.
    //
    // Bewusst NACHGESEHEN statt per CSS.supports gefragt: "kennt die
    // Eigenschaft" ist nicht dasselbe wie "die Animation laeuft". Genau diese
    // Verwechslung hat die Sektion schon einmal still stehen lassen - der
    // Browser meldete Unterstuetzung, die Animation tat nichts, und das
    // Fallback hielt sich trotzdem raus. Wer nichts tut, verliert hier.
    function cssFliesItself(frame) {
      var stage = frame.querySelector('.stl-fb__stage');
      if (!stage || !stage.getAnimations) return false;

      var anims = stage.getAnimations();
      for (var i = 0; i < anims.length; i++) {
        var a = anims[i];
        // Muss an einer Scroll-Timeline haengen, nicht an der Uhr ...
        if (!a.timeline || a.timeline === document.timeline) continue;
        if (a.timeline.currentTime == null) continue;
        // ... die Strecke fuellen (steht hier eine Zahl statt 'auto', ist die
        // Animation sofort am Ende und taeuschte den Einflug nur vor) ...
        if (a.effect.getTiming().duration !== 'auto') continue;
        // ... und sich auf das beziehen, was tatsaechlich scrollt. Eine Timeline
        // sucht sich den naechsten Scroll-Container; ein `overflow` != visible
        // auf body macht IHN dazu, und dann steht sie still, weil sich darin
        // nie etwas bewegt. Genau das hat die Sektion schon einmal lautlos
        // lahmgelegt - lieber ruckelig als tot.
        var quelle = a.timeline.source;
        if (quelle && quelle !== (document.scrollingElement || document.documentElement)) continue;
        return true;
      }
      return false;
    }

    function StlZoomIn(frame) {
      this.frame = frame;
      this.ticking = false;
      this.lastP = -1;
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.init();
    }

    StlZoomIn.prototype.init = function () {
      if (REDUCED.matches) {
        this.frame.style.setProperty('--stl-fb-p', '1');
        return;
      }
      // Erst nach dem ersten Frame entscheiden: vor dem ersten Layout steht
      // die Timeline noch nicht und meldete faelschlich "laeuft nicht" - wir
      // wuerden dann doppelt fahren und uns das Ruckeln zurueckholen.
      var self = this;
      window.requestAnimationFrame(function () {
        // Der Browser macht es selbst - nachweislich, nicht vermutlich.
        if (cssFliesItself(self.frame)) return;
        self.attach();
      });
    };

    StlZoomIn.prototype.attach = function () {
      // Nur rechnen, solange der Rahmen im Blick ist.
      var self = this;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          self.visible = entries[0].isIntersecting;
          if (self.visible) self.onScroll();
          // Etwas Vorlauf, damit der erste Wert steht, bevor der Rahmen den
          // Bildschirm erreicht - dort beginnt die Strecke.
        }, { rootMargin: '15% 0px 15% 0px' });
        this.io.observe(this.frame);
      } else {
        this.visible = true;
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    };

    StlZoomIn.prototype.onScroll = function () {
      if (this.ticking || this.visible === false) return;
      this.ticking = true;
      window.requestAnimationFrame(this.update);
    };

    StlZoomIn.prototype.update = function () {
      this.ticking = false;

      var rect = this.frame.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Dieselben zwei Punkte wie die Strecke im CSS, nur ausgerechnet:
      // Start `cover 0%`  = Oberkante des Rahmens an der unteren
      //                     Bildschirmkante  ->  rect.top == vh.
      // Ziel  `cover 50%` = Rahmen mittig im Bildschirm, also
      //                     rect.top + h / 2 == vh / 2  ->  rect.top == (vh - h) / 2.
      var span = (vh + rect.height) / 2;
      var raw;
      if (span > 0) {
        raw = (vh - rect.top) / span;
      } else {
        raw = 1;
      }

      var p = easeInOutCubic(clamp01(raw));

      // Sub-Pixel-Schreibvorgaenge sparen
      if (Math.abs(p - this.lastP) < 0.002 && p !== 0 && p !== 1) return;
      this.lastP = p;
      this.frame.style.setProperty('--stl-fb-p', p.toFixed(4));
    };

    StlZoomIn.prototype.destroy = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.io) this.io.disconnect();
    };

    function clamp01(v) {
      return v < 0 ? 0 : v > 1 ? 1 : v;
    }

    // Die Perspektive schrumpft von sich aus schon vorne am staerksten
    // (scale = P / (P - z), und z ist am Anfang gross). Ein easeOut wuerde das
    // doppelt vorziehen - das Bild waere nach dem ersten Wisch fast fertig.
    // easeInOut haelt am Anfang dagegen und legt es am Ende sanft ab.
    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function initAll(scope) {
      var frames = (scope || document).querySelectorAll('[data-stl-fb-frame]');
      Array.prototype.forEach.call(frames, function (frame) {
        if (frame.__stlFb) return;
        frame.__stlFb = new StlZoomIn(frame);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme-Editor
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var frames = e.target.querySelectorAll('[data-stl-fb-frame]');
      Array.prototype.forEach.call(frames, function (frame) {
        if (frame.__stlFb) frame.__stlFb.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-about-team"] && !Shopify.designMode) return;
  try {
    
  // Mouse parallax: sets --st-team-mx/--st-team-my (-1..1) on <html>, hover devices only
  (function () {
    if (!document.querySelector('.st-team')) return;
    if (!matchMedia('(hover: hover)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var raf = 0;
    var s = document.documentElement.style;
    addEventListener(
      'mousemove',
      function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          s.setProperty('--st-team-mx', ((e.clientX / innerWidth) * 2 - 1).toFixed(3));
          s.setProperty('--st-team-my', ((e.clientY / innerHeight) * 2 - 1).toFixed(3));
        });
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-hidden-items"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-hidden-items')) {
    customElements.define(
      'st-hidden-items',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const card = event.target.closest('.st-hi-card');
            if (!card || !this.contains(card)) return;
            const found = card.classList.toggle('is-found');
            card.setAttribute('aria-pressed', String(found));
            const count = this.querySelector('[data-count]');
            if (count) count.textContent = this.querySelectorAll('.st-hi-card.is-found').length;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
